var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:var(--ion-color-success);}\n\t.st1{fill:var(--ion-color-white);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-2",
    transform: "translate(251 362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4619-2",
    className: "st0",
    d: "M-235-362c-8.8,0-16,7.2-16,16s7.2,16,16,16c8.8,0,16-7.2,16-16 C-219-354.8-226.2-362-235-362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4620-2",
    className: "st1",
    d: "M-226.9-349.4l-8.7,8.7c-0.5,0.5-1.4,0.5-1.9,0c0,0,0,0,0,0l-4.3-4.3 c-0.5-0.5-0.6-1.3-0.1-1.9c0.5-0.5,1.3-0.6,1.9-0.1c0,0,0.1,0.1,0.1,0.1l3.4,3.4l7.7-7.7c0.5-0.5,1.4-0.5,1.9,0.1 C-226.4-350.7-226.4-349.9-226.9-349.4L-226.9-349.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliCheck);
export default __webpack_public_path__ + "static/media/Deli_Check.8ec5b6044f6d9925c3d989efcdaf1a50.svg";
export { ForwardRef as ReactComponent };